module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAAeFBMVEUAAAD/QkL/QkL/WVn/QkL/QkL/QkL/QkL/QkL/QkL/QkL/QkL/Q0P/QkL/QkL/QkL/9fX/uLj/9PT/Tk7/QkL/QkL/QkL/9fX/T0//hYX/v7//UFD/QkL/jo7/UlL/UFD/aWn/Y2P/QkL/QkL/QkL/////+vr/+fnTLV6uAAAAJHRSTlMACOT999y/uZWRQwX76n55/fv699U7Of79/Pr6+O/u4+LVhIB7ZDXTAAAAh0lEQVQI11XPWRaDIAwF0AQnUNBq1c5z0u5/hw0n8OH7u+SQASQdwjKvgB1oBmMDGWeG5Jo0dQT2DeU0HwQss+4v8gjgEi88kQVoq/CI3B9+BVUtlPTkm3DHhbyWUvcjn45KqYMlGpm/kfJf+58noeSKab7X+W/c7pf3d4aCM32E3rfOi973B88qEIXZdQEdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/content/images/check/detail-expert-icon.png
// module id = w7Rz
// module chunks = 11